<div
  data-testid="magicbag"
  class="c-magicbag">
  <div class="c-magicbag__container">
    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <slotcom-navigation-button
      type="info"
      (click)="openInfoModal()">
    </slotcom-navigation-button>
    <div
      class="c-magicbag__background"
      theming
      themingGroup="magicbag"
      themingAsset="background"
      [themingOverride]="event()?.assets">
      <div
        class="c-magicbag__info"
        data-testid="magicbag-info">
        <div
          class="c-magicbag__multiplier"
          data-testid="magicbag-multiplier">
          <div
            class="c-magicbag__bag-icon"
            theming
            themingGroup="magicbag"
            themingAsset="bag-icon"
            [themingOverride]="event()?.assets"></div>
          <span class="text multiplier">x{{ event()?.properties?.magicbagmultiplier }}</span>
        </div>

        <div class="c-magicbag__display">
          <slotcom-display
            data-testid="slotcom-multiplier-offer"
            [classes]="['c-display--auto', 'c-display--magicbag']">
            <div
              displayIcon
              displayIconPos="left"
              theming
              themingGroup="none"
              themingAsset="credits-lineless"
              class="c-display--coin"></div>

            <span
              counto
              [delay]="500"
              [countFrom]="currentBonus()"
              [countTo]="rewardBonus()"
              (countoChange)="valueMultiplied = $event">
              {{ valueMultiplied | number: '1.0-0' : ('common.culture' | translate) }}
            </span>
          </slotcom-display>
        </div>

        <slotcom-box
          class="maxCompletionTimes"
          [classes]="['maxCompletionTimes--blue']">
          @if (!event()?.infiniteTimes && event()?.maxCompletionTimes === 1) {
            <span class="text times">{{ 'home.live-ops.global.times-valid-coins' | translate }}</span>
          }
          @if (!event()?.infiniteTimes && event()?.maxCompletionTimes > 1) {
            <span class="text times">{{
              'home.live-ops.global.times-valid-coins-2' | translate: { times: event()?.maxCompletionTimes }
            }}</span>
          }
          @if (event()?.infiniteTimes) {
            <span class="text times">{{ 'home.live-ops.global.times-valid-coins-3' | translate }}</span>
          }
        </slotcom-box>

        @if (magicbagMinPurchase() && +magicbagMinPurchase() !== 0) {
          <span class="text min-purchase"
            >{{ 'home.live-ops.global.min-purchase' | translate | uppercase }} {{ magicbagMinPurchase() }}
            {{ magicbagCurrencySymbol() }}</span
          >
        }

        <div class="c-magicbag__timer">
          <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="event()?.endDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>

      <slotcom-button
        data-testid="magicbag-button"
        class="c-button--pink"
        (safeClick)="manageMagicBag()"
        audioType="functionality">
        {{
          persistedModalData()?.properties?.buttonText?.[lang()]
            ? persistedModalData()?.properties?.buttonText?.[lang()]
            : ('home.buttons.discover-offers' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
